//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Swiper from "swiper";
import axios from "axios";
export default {
  name: "newdetails",
  data() {
    return {
      idx: 3,
      html: "",
      banner: [],
      nav: [
        {
          text: "首页",
          status: "0",
        },
        {
          text: "关于中启",
          status: "1",
        },
        {
          text: "工程案例",
          status: "2",
        },
        {
          text: "新闻中心",
          status: "3",
        },
        {
          text: "业务中心",
          status: "4",
        },
        {
          text: "人力资源",
          status: "5",
        },
        {
          text: "联系我们",
          status: "6",
        },
      ],
    };
  },
  updated: function () {
    new Swiper(".swiper1", {
      spaceBetween: 30,
      centeredSlides: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  },
  mounted() {
    const _this = this;
    _this.details();
  },
  methods: {
    details() {
      const _this = this;
      let Base64 = require("js-base64").Base64;
      var id = this.$route.query.id;
      _this.$post("/header/news/fetchOne/" + id).then((res) => {
        _this.banner = res.data.bannerList;
        _this.html = Base64.decode(res.data.responseNewsListVo.newContent);
      });
    },
    collect_click() {
      alert("请按住Ctrl+D收藏网站");
    },
    //导航跳转
    rout(a) {
      if (a == 0) {
        this.$router.push({
          path: "/",
        });
      } else if (a == 1) {
        this.$router.push({
          path: "/about",
        });
      } else if (a == 2) {
        this.$router.push({
          path: "/project",
        });
      } else if (a == 3) {
        this.$router.push({
          path: "/new",
        });
      } else if (a == 4) {
        this.$router.push({
          path: "/business",
        });
      } else if (a == 5) {
        this.$router.push({
          path: "/recruit",
        });
      } else if (a == 6) {
        this.$router.push({
          path: "/contact",
        });
      }
    },
    //tab点击事件
    tab_click(a) {
      const _this = this;
      _this.goodsstatus = a;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/newdetails.vue